import React, { useCallback, useMemo, useState } from 'react';

import { useDebouncedEffect } from '../../hooks/useDebouncedEffect';

import { getInstitutionsByLink } from '../../services/Institutions';

import { useWorkspaceContext } from '../workspace';

import { OfflineInstitutions } from './OfflineInstitutions';

export const useSystemNotificationsProvider = () => {
  const [toasts, setToasts] = useState([]);
  const { workspace: { defaultWorkspace } } = useWorkspaceContext();

  const addToast = (toast) => {
    const key = toast.key || Date.now();

    if (toasts.find((toastEl) => toastEl.key === key)) {
      return;
    }

    const rest = toasts.length < 3 ? toasts : toasts.slice(0, -1);

    setToasts([{ ...toast, key }, ...rest]);
  };

  const removeToast = (key) => {
    setToasts((prev) => prev.filter((toast) => toast.key !== key));
  };

  const value = useMemo(() => ({
    toasts,
    setToasts,
    addToast,
    removeToast,
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [toasts]);

  const offlineInstitutionsMsg = useCallback(({ id, description }) => ({
    key: `offline-institutions-${id}`,
    children: <OfflineInstitutions id={id} description={description} />,
  }), []);

  useDebouncedEffect(() => {
    const init = async () => {
      try {
        // Only bank-connection instability surfaces as a banner now. Investment
        // expiry ("CDBs que vencem hoje" etc.) intentionally no longer toasts.
        const offlineInstitutions = await getInstitutionsByLink();

        setToasts(offlineInstitutions.length > 0 ? offlineInstitutions.map(offlineInstitutionsMsg) : []);
      } catch (_error) {
        // ignora
      }
    };

    if (defaultWorkspace.id) init();
  }, [defaultWorkspace.id], 500);

  return value;
};
